import { Goal, MetricEntryMode, NewGoal } from '@griply/types';
import { endOfDay } from 'date-fns';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const goalConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): Goal => {
    const data = firebaseObjectTimestampToDate(snapshot.data()) as Record<
      string,
      unknown
    >;

    return {
      ...data,
      name:
        typeof data.name === 'string'
          ? (data.name as string).trim()
          : data.name,
      startDate: data.startDate ?? null,
      updatedAt: data.updatedAt ?? null,
      deadline: data.deadline ?? null,
      completedAt: data.completedAt ?? null,
      createdAt: data.createdAt ?? new Date(),
      archivedAt: data.archivedAt ?? null,
      frozenAt: data.frozenAt ?? null,
      iconName: data.iconName ?? null,
      image: data.image ?? null,
      metric: data.metric
        ? {
            ...(data.metric as Record<string, unknown>),
            startValue:
              typeof (data.metric as Record<string, unknown>).startValue ===
              'number'
                ? Math.round(
                    ((data.metric as Record<string, unknown>)
                      .startValue as number) * 100,
                  ) / 100
                : null,
            targetValue:
              typeof (data.metric as Record<string, unknown>).targetValue ===
              'number'
                ? Math.round(
                    ((data.metric as Record<string, unknown>)
                      .targetValue as number) * 100,
                  ) / 100
                : null,
            entries:
              (data.metric as Record<string, unknown>).entries &&
              Array.isArray((data.metric as Record<string, unknown>).entries)
                ? (
                    (data.metric as Record<string, unknown>).entries as Array<
                      Record<string, unknown>
                    >
                  ).map(({ value, mode, ...entry }) => ({
                    ...entry,
                    value:
                      typeof value === 'number'
                        ? Math.round(value * 100) / 100
                        : value,
                    mode: mode ?? MetricEntryMode.Absolute,
                  }))
                : null,
          }
        : null,
      sections: data.sections ?? null,
    } as Goal;
  },
  toFirestore: (goal: Goal) => goal,
};

export const newGoalConverter = (goal: NewGoal) => ({
  ...goal,
  createdAt: new Date(),
  image: goal.image ?? null,
  lifeAreaId: goal.lifeAreaId ?? null,
  frozenAt: null,
  startDate: goal.startDate ? new Date(goal.startDate) : null,
  deadline: goal.deadline ? endOfDay(goal.deadline) : null,
  parentIds: goal.parentIds?.length
    ? Array.from(new Set(goal.parentIds))
    : null,
  completedAt: null,
  archivedAt: null,
});
